import type { ComponentType } from "react";
import { ReasoningBubble } from "./ReasoningBubble";

interface CopilotMessage {
  id: string;
  role: string;
  content: string;
}

interface CustomMessageProps {
  message: CopilotMessage;
  streaming: boolean;
  DefaultRenderer: ComponentType<{ message: CopilotMessage }>;
}

// The AG-UI REASONING_MESSAGE_* event triple causes the @ag-ui/client to
// construct a message with role="reasoning". We detect that here to route
// Grok extended thinking tokens to the collapsed <ReasoningBubble> rather
// than the default assistant message renderer.
export function CustomMessage({ message, streaming, DefaultRenderer }: CustomMessageProps) {
  if (message.role === "reasoning") {
    return <ReasoningBubble content={message.content} streaming={streaming} />;
  }
  return <DefaultRenderer message={message} />;
}
